import { gql } from "@apollo/client";

export const GET_KETO_RESUMEN = gql`
query GetKetoById($idDatosGenerales: Int!) {
    ketosterilRIByDatosGeneralesId(idDatosGenerales: $idDatosGenerales){
        ketosterilRI {
            idComboRIValorERCestadioNavigation{
                valor
            }
            laboratorio
            fG
            recuperacionRenalDialisis
            txrenalConDeterioro
            quiereDialisis
            hemodialisisIncremental
        }
        laboratorioAdjunto {
            contentType
            titulo
            archivo
            extension
        }
    }
}
`;